import { createViewStateSubscription } from '@databases/database-state/state/view';
import { createViewChangesInput } from '@databases/selections';

import { SelectionFeatureKeys, type SelectionInputFeature } from '../../features/types';

export interface ViewChangesInputFeatureDeps {
  createViewStateSubscription: (onChange: VoidFunction) => VoidFunction;
}

export function createViewChangesInputFeature(): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.VIEW_CHANGES_INPUT,
    type: 'input',
    // No isEnabled — always active when mode includes it.
    factory: (machine) => {
      return createViewChangesInput(machine, createViewStateSubscription);
    },
  };
}
